import React, { useRef, useEffect, useState, useContext } from "react";

// Componentes PrimeReact
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { InputText } from "primereact/inputtext";

import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext"; 

import { getActivosFijos } from "../../../../../../API/Global/ActivosFijos/ActivosFijosRequest";

const ActivosFijosOverlayPanel = ({ close, rowData, onChange }) => {
  const op = useRef(null);
  const buttom = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [activosF, setActivosF] = useState([]);

  const obtenerActivosFijos = async () => {
    setLoading(true);
    const tempo = await getActivosFijos();
    setActivosF(tempo.filter(i => i?.ActivoPadre === false));
    setLoading(false);

  };

  const columns = [
    {
      field: "IdActivo",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
    },
    {
      field: "Type",
      header: "Tipo",
      headerEn: "Type",
      className: "small",
    },
    {
      field: "CodigoActivo",
      header: "Código",
      headerEn: "Code",
      className: "Xsmall",
    },
    {
      field: "NombreActivo",
      header: "Nombre",
      headerEn: "Name",
      className: "large",
      flex: 1,
      minWidth: 300,
    },
    {
      field: "Marca",
      header: "Marca",
      headerEn: "Brand",
      className: "medium",
    },
    {
      field: "Modelo",
      header: "Modelo",
      headerEn: "Modelo",
      className: "medium",
    },
    {
      field: "NombreCompleto",
      header: "Asignado",
      headerEn: "Asignado",
      className: "medium",
    },
    {
      field: "Area",
      header: "Área",
      headerEn: "Area",
      className: "Xsmall",
    },
  ];
  const table = {
    Columns: columns,
    Data: activosF,
    loading: loading,
    onCellClicked: (e) => onChange(e, rowData),
  };

  useEffect(() => {
    obtenerActivosFijos();
  }, []);

  return (
    <div style={{ maxWidth: "50vw" }}>
      <div className="p-inputgroup">
        <InputText
          value={rowData.NombreProducto}
          disabled
          placeholder="CodigoActivo"
          onClick={(e) => op.current.toggle(e)}
        />
        <Button
          ref={buttom}
          icon="pi pi-chevron-down"
          style={{ padding: "0.5rem 0.3rem" }}
          type="button"
          onClick={(e) => op.current.toggle(e)}
        />
      </div>

      <OverlayPanel
        ref={op}
        showCloseIcon
        dismissable={false}
        className="OverPanelProductos"
        onHide={close}
      >
        <div style={{ width: 1300, height: 300 }}>
          <AgGrid table={table} />
        </div>
      </OverlayPanel>
    </div>
  );
};

export default ActivosFijosOverlayPanel;
